var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.locale},on:{"change":_vm.onChange,"focus":_vm.setOld}},[_c('option',{attrs:{"value":"en"}},[_vm._v("🇺🇸 English")]),_c('option',{attrs:{"value":"ar"}},[_vm._v("🇸🇦 Arabic")])])}
var staticRenderFns = []

export { render, staticRenderFns }